function getApartmentCategory(unitMix, apartment) {
  return unitMix.find((item) => item.label === apartment.data.category);
}
export {
  getApartmentCategory
};
//# sourceMappingURL=index110.js.map
